module.exports = __webpack_public_path__ + "static/media/server.4cf1848d.svg";